/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNotify } from "react-admin";
import { API, graphqlOperation } from "aws-amplify";
import {
  searchInventorys,
  inventoryItemByLocationByStatus,
} from "../../../../graphql/inventory/custom-queries";
import { locationByAisleBySortKey } from "../../../../graphql/reloadyard/custom-queries";
import {
  Box,
  Grid,
  Divider,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  useMediaQuery,
  FormControlLabel,
  Switch,
  Typography,
} from "@material-ui/core";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import { makeStyles } from "@material-ui/core/styles";
import {
  InventoryStatus,
  LocationLoadType,
  LocationType,
} from "../../../../utils/constants";
import { getLocationFullName } from "../../../../utils/locationUtils";
import { getUnitName } from "../../../../utils/loadTypeUtils";
import { exceptionRenderer } from "../../../../utils/utils";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { green } from "@material-ui/core/colors";
import { logError } from "../../../../utils/appUtils";
import { AisleControl } from "./AisleControl";
import { StructuredAisle } from "./StructuredAisle";
import SearchInput from "../../../../components/common/SearchInput";
import LocationCapacity, {
  StructuredLocationCapacity,
} from "../../../../components/common/LocationCapacity";
import { useInventorySearchContext } from "../context";

const useStyles = makeStyles((theme) => ({
  spacer: {
    marginTop: theme.spacing(1),
  },
  iconButton: {
    marginTop: theme.spacing(0.25),
  },
  backdrop: {
    zIndex: 1001,
  },
}));

export const AisleMap = ({
  handleSave,
  handleAreaChange,
  handleZoneChange,
  isSaveButtonDisabled,
  scannedQuantity,
}) => {
  const { state, dispatch } = useInventorySearchContext();
  const {
    currentInventory,
    selectedAisle,
    selectedLocation,
    selectedZone,
    showCapacityDisplay,
    showInventoryQuantity,
    selectedInventoryItem,
    aisles,
    originalInventoryItem,
    bayList,
    selectedLocationInventories,
  } = state;
  // const [loadTypeName, setLoadTypeName] = useState();
  // const [totalQuantity, setTotalQuantity] = useState();
  // const [showTotalQuantity, setShowTotalQuantity] = useState(false);
  const [showInventories, setShowInventories] = useState();
  const [mapLoading, setMapLoading] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const isMedium = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const classes = useStyles();
  const notify = useNotify();

  useEffect(() => {
    if (selectedZone) {
      init();
    }
  }, [selectedZone]);

  useEffect(() => {
    if (selectedLocation && selectedZone && bayList?.length !== 0) {
      handleLocation();
    }
  }, [bayList, selectedZone, selectedLocation]);

  const init = () => {
    if (selectedAisle) {
      handleAisleChange(selectedAisle.id, false, true);
    }
  };

  const handleLocation = async () => {
    dispatch({ type: "SET_SELECTED_LOCATION_INVENTORIES", payload: [] });
    getInventories();
  };

  const getInventories = async () => {
    try {
      debugger;
      const results = await Promise.all([
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.IN_TRANSIT },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.UNLOADED },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.REVIEW },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.STORED },
          }),
        ),
      ]);
      const inventoryItemsList = [
        ...results[0].data.inventoryItemByLocationByStatus.items,
        ...results[1].data.inventoryItemByLocationByStatus.items,
        ...results[2].data.inventoryItemByLocationByStatus.items,
        ...results[3].data.inventoryItemByLocationByStatus.items,
      ];

      if (inventoryItemsList.length > 0) {
        inventoryItemsList.sort((a, b) => {
          // Sort by accountName ASCENDING
          const accountNameCompare = a.inventory.accountName.localeCompare(
            b.inventory.accountName,
          );
          if (accountNameCompare !== 0) return accountNameCompare;

          // If accountName is the same, sort by productName ASCENDING
          const productNameNameCompare = a.inventory.productName.localeCompare(
            b.inventory.productName,
          );
          if (productNameNameCompare !== 0) return productNameNameCompare;

          // If productName is also the same, sort by quantityOnHand DESCENDING
          return b.quantityOnHand - a.quantityOnHand;
        });

        // const loadTypeName = inventoryItemsList[0].inventory.reloadYardCommodity.commodity.locationLoadType.toLowerCase();
        // const sameLoadType = inventoryItemsList.reduce((accumulator, itm) =>
        //     accumulator && itm.inventory.reloadYardCommodity.commodity.locationLoadType === loadTypeName, true);
        // if (sameLoadType && selectedLocation.type === LocationType.STRUCTURED
        //     && selectedLocation.locationLoad[loadTypeName].selected) {
        //     const totalQuantity = inventoryItemsList.reduce((accumulator, itm) => accumulator + itm.quantityOnHand, 0);
        //     setTotalQuantity(totalQuantity);
        //     setLoadTypeName(loadTypeName[0].toUpperCase() + loadTypeName.substring(1));
        //     setShowTotalQuantity(true);
        // }
        dispatch({
          type: "SET_SELECTED_LOCATION_INVENTORIES",
          payload: inventoryItemsList,
        });
      }
    } catch (error) {
      logError("inventorySearch:AisleMap:getInventories", error, notify);
    } finally {
      // setMapLoading(false);
    }
  };

  const handleAisleChange = async (
    aisleId,
    loadingFlag = true,
    setOriginalLocationBayList = false,
  ) => {
    try {
      debugger;
      setMapLoading(loadingFlag);
      if (!aisleId || aisles?.length === 0) return;
      const response = await API.graphql(
        graphqlOperation(locationByAisleBySortKey, { aisleId, limit: 1000 }),
      );
      const aisle = aisles.find((itm) => itm.id === aisleId);
      aisle.locations = response.data.locationByAisleBySortKey.items.filter(
        (itm) => itm.active === "true",
      );

      const { showCapacityDisplay, bayList } = setupAisle(aisle);
      let location;
      if (aisle.type === LocationType.UNSTRUCTURED) {
        location = aisle.locations[0];
      }

      const payload = {
        aisle,
        bayList,
        showCapacityDisplay,
        selectedLocation: location,
      };
      if (setOriginalLocationBayList) {
        debugger;
        payload.inventoryItemBayList = bayList;
      }
      dispatch({ type: "SET_SELECTED_AISLE", payload });
      debugger;
      if (
        aisle.type === LocationType.STRUCTURED &&
        !aisle.locationLoad.other.selected
      ) {
        const inventoryLoadType =
          currentInventory.reloadYardCommodity.commodity.locationLoadType;
        const locationLoadType = aisle.locationLoad[inventoryLoadType];
        if (
          inventoryLoadType !== LocationLoadType.OTHER &&
          locationLoadType?.selected
        ) {
          dispatch({
            type: "SET_SELECTED_INVENTORY_ITEM",
            payload: {
              ...selectedInventoryItem,
              quantityOnHand: 1,
            },
          });
        }
      } else {
        dispatch({
          type: "SET_SELECTED_INVENTORY_ITEM",
          payload: {
            ...selectedInventoryItem,
            quantityOnHand: originalInventoryItem.quantityOnHand,
          },
        });
      }
      if (showCapacityDisplay) getShowQuantity();
    } catch (err) {
      logError(
        "processInboundShipments:InboundAisleMap:handleAisleChange",
        err,
        notify,
      );
    } finally {
      setMapLoading(false);
    }
  };

  const getShowQuantity = () => {
    let showValue;
    if (
      currentInventory.reloadYardCommodity.commodity.locationLoadType ===
      "other"
    ) {
      showValue = false;
    } else {
      showValue = localStorage.getItem("locationCapacityDisplay");
      showValue = showValue !== null ? JSON.parse(showValue) : false;
    }
    dispatch({ type: "SET_SHOW_QUANTITY", payload: showValue });
  };

  const setupAisle = (aisle) => {
    const bayList = [];
    if (aisle.type === LocationType.UNSTRUCTURED) {
      return { showCapacityDisplay: false, bayList: [null, [aisle.locations]] };
    }
    const capacityTypeMap = {
      pallet: {},
      box: {},
      container: {},
      superSack: {},
    };
    let showRadio = true;

    for (let location of aisle.locations) {
      const bay = location.bay;
      if (!bayList[bay]) bayList[bay] = [];
      const level = location.level;
      if (!bayList[bay][level - 1]) bayList[bay][level - 1] = [];
      bayList[bay][level - 1].push(location);

      if (location.locationLoad.other.selected) showRadio = false;
      if (location.locationLoad.pallet.selected)
        capacityTypeMap["pallet"][location.locationLoad.pallet.capacity] = true;
      if (location.locationLoad.box.selected)
        capacityTypeMap["box"][location.locationLoad.box.capacity] = true;
      if (location.locationLoad.container.selected)
        capacityTypeMap["container"][location.locationLoad.container.capacity] =
          true;
      if (location.locationLoad.superSack.selected)
        capacityTypeMap["superSack"][location.locationLoad.superSack.capacity] =
          true;
    }
    debugger;
    let showCapacityDisplay = false;
    if (showRadio) {
      const capacityTypeMapValues = Object.values(capacityTypeMap);
      const numberOfCapacities = capacityTypeMapValues.reduce(
        (total, itm) => (total += Object.keys(itm).length > 0 ? 1 : 0),
        0,
      );
      if (numberOfCapacities === 1) showCapacityDisplay = true;
    }

    bayList.splice(0, 1);
    for (let bay of bayList) {
      if (!bay || bay.length === 0) continue;
      for (let level of bay) {
        level.sort((a, b) => {
          return a.position - b.position;
        });
      }
    }

    return { showCapacityDisplay, bayList };
  };

  // const handleSaveBelow = async () => {
  //     const bay = bayList[selectedLocation.bay - 1];
  //     const topLocation = bay[bay.length - 1][selectedLocation.position - 1];
  //     let levels = bay.filter(level => level[0].level >= selectedLocation.level);
  //     if (selectedInventoryItem.location.bay === selectedLocation.bay
  //         && selectedInventoryItem.position === selectedLocation.position) {
  //         levels = levels.filter(level => level[0].level < selectedInventoryItem.location.level);
  //     }
  //     levels = levels.map(level => level.filter(
  //         itm => itm.position === selectedLocation.position
  //         && itm.id !== topLocation.id
  //         && itm.id !== selectedInventoryItem.location.id));
  //     levels = levels.filter(itm => itm.length > 0);
  //     if (levels.length > 0) {
  //         try {
  //             dispatch({type: "SET_LOADING", payload: true});
  //             const origLocationToNewLocation = {};
  //             const newLocationToOrigLocation = {};
  //             for (let level of levels) {
  //                 for (let location of level) {
  //                     const newLocation = bay[location.level][location.position - 1];
  //                     origLocationToNewLocation[location.id] = {...newLocation};
  //                     newLocationToOrigLocation[newLocation.id] = {...location};
  //                 }
  //             }
  //             let promiseList = Object.keys(origLocationToNewLocation).map(locationId => {
  //                 return API.graphql(graphqlOperation(inventoryItemByLocationByStatusLookup, { locationId }));
  //             })
  //             const response = await Promise.allSettled(promiseList);
  //             const toUpdateInventoryItems = [];
  //             for (let levelInveltoryItems of response) {
  //                 toUpdateInventoryItems.push(...levelInveltoryItems.value.data.inventoryItemByLocationByStatus.items);
  //             }
  //             debugger;
  //             if (!currentInventory.history) currentInventory.history = [];
  //             toUpdateInventoryItems.forEach(inventoryItem => {
  //                 const newLocation = origLocationToNewLocation[inventoryItem.locationId];
  //                 inventoryItem.locationId = newLocation.id;
  //                 inventoryItem.aisleId = newLocation.aisleId;
  //                 inventoryItem.zoneId = newLocation.zoneId;
  //                 inventoryItem.areaId = newLocation.areaId;
  //                 const newLocationFullName = getLocationFullName(newLocation);
  //                 const historyText = `${inventoryItem.quantityOnHand} ${getUnitName(currentInventory.inventoryUOM)} moved `
  //                     + `from ${inventoryItem.locationFullName} to ${newLocationFullName}`;
  //                 const newHistory = {
  //                     type: NoteType.SHIPMENT,
  //                     date: new Date(),
  //                     by: window.appUser?.fullName,
  //                     text: historyText
  //                 };
  //                 currentInventory.history.push(newHistory);
  //                 inventoryItem.locationFullName = newLocationFullName;
  //             });
  //             promiseList = toUpdateInventoryItems.map(itm => {
  //                 return API.graphql(graphqlOperation(updateInventoryItemMini, { input: itm }));
  //             });
  //             Object.values(origLocationToNewLocation).map(itm => {
  //                 const toUpdateLocation = {
  //                     id: itm.id,
  //                     aisleId: itm.aisleId,
  //                     zoneId: itm.zoneId,
  //                     areaId: itm.areaId,
  //                     reloadYardId: itm.reloadYardId,
  //                     sortKey: itm.sortKey,
  //                     capacityUsed: newLocationToOrigLocation[itm.id].capacityUsed,
  //                 };
  //                 return promiseList.push(API.graphql(graphqlOperation(updateLocationMini, { input: toUpdateLocation })));
  //             });
  //             const results = await Promise.allSettled(promiseList);
  //             const resError = results.find(itm => itm.status === "rejected");
  //             if (resError) {
  //                 logError("processInboundShipments:InboundAisleMap:handleSaveBelow", resError, notify);
  //             }
  //             await handleSave(true);
  //             debugger;
  //             handleAisleChange(selectedAisle.id);
  //         } catch (err) {
  //             logError("processInboundShipments:InboundAisleMap:handleSaveBelow", err, notify);
  //         } finally {
  //             dispatch({type: "SET_LOADING", payload: false});
  //         }
  //     }
  // }

  const getGeoLocation = (inventoryItem) => {
    if (navigator.geolocation) {
      try {
        navigator.geolocation.getCurrentPosition((position) => {
          if (position) {
            inventoryItem.latitude = position.coords.latitude;
            inventoryItem.longitude = position.coords.longitude;
            // TODO: fix this issue, happens after electedInventoryItem is updated
            // setSelectedInventoryItem({...selectedInventoryItem});
          }
        });
      } catch (err) {
        logError(
          "processInboundShipments:InboundAisleMap:handleLocation",
          err,
          notify,
        );
      } finally {
        dispatch({
          type: "SET_SELECTED_INVENTORY_ITEM",
          payload: inventoryItem,
        });
      }
    }
  };

  const isShipmentInventoryItem = (itm) => {
    return itm.inventory.id === currentInventory.id;
  };

  const getFromAisleComponent = () => {
    if (selectedAisle?.id) {
      return selectedAisle.type === LocationType.STRUCTURED ? (
        <StructuredAisle />
      ) : null;
    }
  };

  const searchAisleInventories = async () => {
    try {
      if (searchTerm.length === 0) return;
      dispatch({ type: "SET_LOADING", payload: true });
      const searchInput = {
        sort: { field: "productName", direction: "asc" },
        filter: {
          reloadYardId: { eq: window.appUser.reloadYardId },
          status: { eq: InventoryStatus.STORED },
          aisleList: { match: selectedAisle.id },
        },
        limit: 1000,
      };
      const term = searchTerm.toLowerCase();
      searchInput.filter.or = [
        { productCode: { matchPhrasePrefix: `${term}` } },
        { productCode: { wildcard: `*${term}*` } },
        { productName: { matchPhrasePrefix: `${term}` } },
        { productName: { wildcard: `*${term}*` } },
        { accountName: { matchPhrasePrefix: `${term}` } },
        { accountName: { wildcard: `*${term}*` } },
        { lotNumber: { matchPhrase: `${term}` } },
        { lotNumber: { wildcard: `*${term}*` } },
        { railCarNumber: { matchPhrasePrefix: `${term}` } },
        { railCarNumber: { wildcard: `*${term}*` } },
        { customFields: { matchPhrasePrefix: `${term}` } },
        { customFields: { wildcard: `*${term}*` } },
      ];
      const response = await API.graphql(
        graphqlOperation(searchInventorys, searchInput),
      );
      const data = response.data.searchInventorys.items;
      setupAisleInventoryItems(data);
      debugger;
    } catch (err) {
      logError(
        "processInboundShipments:InboundAisleMap:showInventory",
        err,
        notify,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const setupAisleInventoryItems = (inventories) => {
    const aisleInventories = [];
    inventories.forEach((inventory) => {
      const inventoryItems = inventory.inventoryItems.items.filter(
        (itm) => itm.aisleId === selectedAisle.id,
      );
      aisleInventories.push(...inventoryItems);
    });
    const searchInventoryItemsMap = {};
    aisleInventories.forEach((itm) => {
      const locationInventories = searchInventoryItemsMap[itm.locationId];
      if (!locationInventories) searchInventoryItemsMap[itm.locationId] = [itm];
      else searchInventoryItemsMap[itm.locationId].push(itm);
    });
    dispatch({
      type: "SET_AISLE_SEARCH_INVENTORIES",
      payload: searchInventoryItemsMap,
    });
  };

  const clearSearchResults = () => {
    setSearchTerm("");
    dispatch({ type: "SET_AISLE_SEARCH_INVENTORIES", payload: [] });
  };

  const handleDisplayChange = (evt) => {
    setShowQuantity(evt.target.checked);
  };

  const setShowQuantity = (value) => {
    // Switch between percentage and quantity
    localStorage.setItem("locationCapacityDisplay", value);
    dispatch({ type: "SET_SHOW_QUANTITY", payload: value });
  };

  // Capacity is shown for the location the stock is leaving as well as the one
  // it is going to. An item that never resolved a Location -- the
  // UNSPOTTED_VIRTUAL sentinel written when a railcar is un-spotted -- has no
  // from side to report, so only the destination's capacity is offered.
  const getLocationCapacity = () => {
    const capacityList = [];
    const fromLocation = originalInventoryItem.location;
    if (fromLocation?.type === LocationType.UNSTRUCTURED) {
      capacityList.push(
        <Grid item xs={12}>
          <LocationCapacity aisle={selectedAisle} />
        </Grid>,
      );
    } else if (fromLocation?.locationLoad?.["other"]?.selected) {
      capacityList.push(
        <Grid item xs={12}>
          <StructuredLocationCapacity
            location={selectedLocation}
            updateFn={() => handleAisleChange(selectedAisle.id)}
          />
        </Grid>,
      );
    }
    const itemLocation = selectedInventoryItem.location;
    if (selectedLocation && itemLocation) {
      if (selectedLocation.type === LocationType.UNSTRUCTURED) {
        if (selectedLocation.id !== itemLocation.id) {
          capacityList.push(
            <Grid item xs={12}>
              <LocationCapacity aisle={itemLocation.aisle} />
            </Grid>,
          );
        }
      } else if (selectedLocation.locationLoad["other"].selected) {
        const isDisabled = selectedLocation.id === itemLocation.id;
        if (selectedLocation.id !== itemLocation.id) {
          capacityList.push(
            <Grid item xs={12}>
              <StructuredLocationCapacity
                location={selectedLocation}
                disabled={isDisabled}
                updateFn={() => handleAisleChange(selectedAisle.id)}
              />
            </Grid>,
          );
        }
      }
    }
    return capacityList.reverse();
  };

  const getViewInventoriesAlignment = () => {
    return isMedium ? "flex-end" : "flex-start";
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Backdrop
          className={classes.backdrop}
          style={{ zIndex: 1001 }}
          open={mapLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <AisleControl
          handleSave={handleSave}
          handleAisleChange={handleAisleChange}
          handleAreaChange={handleAreaChange}
          handleZoneChange={handleZoneChange}
          isSaveButtonDisabled={isSaveButtonDisabled}
          scannedQuantity={scannedQuantity}
          classes={classes}
        />

        {selectedAisle?.type === LocationType.STRUCTURED && (
          <Grid item xs={12} md={6}>
            <SearchInput
              handleSearch={searchAisleInventories}
              clear={clearSearchResults}
              term={searchTerm}
              setTerm={setSearchTerm}
              termLength={3}
            />
          </Grid>
        )}
        {selectedAisle?.type === LocationType.STRUCTURED &&
          showCapacityDisplay && (
            <Grid item xs={12} sm={6} md={3}>
              <Box
                display="flex"
                justifyContent={isMedium ? "flex-end" : "flex-start"}
              >
                <FormControlLabel
                  className={isMedium ? classes.spacer : ""}
                  style={{ paddingLeft: 4 }}
                  control={
                    <Switch
                      checked={showInventoryQuantity}
                      onChange={handleDisplayChange}
                      color="primary"
                    />
                  }
                  label="Show quantity"
                />
              </Box>
            </Grid>
          )}
        {
          <Grid
            item
            xs={12}
            sm={selectedAisle?.type === LocationType.STRUCTURED ? 6 : undefined}
            md={selectedAisle?.type === LocationType.STRUCTURED ? 3 : undefined}
          >
            <Box display="flex" justifyContent={getViewInventoriesAlignment()}>
              <Button
                disabled={
                  !selectedLocation || selectedLocationInventories.length === 0
                }
                onClick={() => setShowInventories(true)}
                startIcon={<VisibilityIcon />}
                size="large"
                className={isMedium ? classes.spacer : ""}
                style={{ paddingLeft: 4 }}
              >
                View Inventories
              </Button>
            </Box>
          </Grid>
        }
        {getLocationCapacity()}
      </Grid>
      <Grid item xs={12}>
        <Box mt={2} mb={2}></Box>
      </Grid>
      <Grid container item xs={12}>
        {getFromAisleComponent()}
      </Grid>

      <Dialog
        open={showInventories}
        onClose={() => setShowInventories(false)}
        fullWidth={true}
        fullScreen={isSmall}
        maxWidth="md"
      >
        <Box
          component="span"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          m={2}
        >
          <Typography variant="h6">{`${getLocationFullName(
            selectedLocation,
          )} inventories`}</Typography>
          <CancelOutlinedIcon
            fontSize="large"
            onClick={() => setShowInventories(false)}
          />
        </Box>
        <DialogContent>
          {selectedLocationInventories.length > 0 && (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell>
                      {isSmall ? "Onhd" : "Quantity Onhand"}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedLocationInventories.map((itm) => (
                    <TableRow key={itm.id}>
                      <TableCell scope="row">
                        <Box
                          display="flex"
                          alignItems="center"
                          component="span"
                        >
                          {isShipmentInventoryItem(itm) ? (
                            <CheckIcon
                              style={{ marginRight: 4, color: green[500] }}
                              fontSize="small"
                            />
                          ) : (
                            <CloseIcon
                              style={{ marginRight: 4 }}
                              fontSize="small"
                            />
                          )}
                          {itm.inventory.productName}
                          {/* Damage keeps every event on its own row, so a
                              quarantine location can hold several rows of the
                              same product. The red glyph is what tells them
                              apart, and its tooltip names the origin of the
                              damage. exceptionRenderer decides which glyph an
                              item earns and renders nothing for clean stock, so
                              no branch of it is re-stated here -- a condition
                              listing a subset of its cases would silently drop
                              a glyph every other grid still draws. */}
                          <Box component="span" ml={0.5} display="inline-flex">
                            {exceptionRenderer(itm)}
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>{itm.inventory.accountName}</TableCell>
                      <TableCell>{`${itm.quantityOnHand} ${
                        !isSmall
                          ? getUnitName(currentInventory.inventoryUOM)
                          : ""
                      }`}</TableCell>
                      {/* <TableCell align="right">{getInventoryPrimaryField(itm.inventory)}</TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {/* {
                    showTotalQuantity && <Box mt={1}>
                        {`Total quantity: ${totalQuantity} ${loadTypeName}`}
                    </Box>
                } */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowInventories(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
